import { render, staticRenderFns } from "./ModuleMonitorPleionV1.vue?vue&type=template&id=6f8b7ca4&scoped=true&"
import script from "./ModuleMonitorPleionV1.vue?vue&type=script&lang=js&"
export * from "./ModuleMonitorPleionV1.vue?vue&type=script&lang=js&"
import style0 from "./ModuleMonitorPleionV1.vue?vue&type=style&index=0&id=6f8b7ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b7ca4",
  null
  
)

export default component.exports